import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    getAllGroups,
    getFactoryByGroupID,
    GetBankReconciliationReport,
    getfactoriesForDropDown,
    getGroupsForDropdown,
    GetReconciliationClosingBalance,
    getTranLedgerListForDropdown,
    getTranLedgerListForDropdownAuto,
    SaveReconciliationCompleteData
};

async function getAllGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups');
    let groupArray = [];
    for (let item of Object.entries(response.data)) {
        if (item[1]['isActive'] === true) {
            groupArray[item[1]['groupID']] = item[1]['groupName'];
        }
    }
    return groupArray;
}

async function getFactoryByGroupID(groupID) {
    let response = await CommonGet(
        '/api/Group/GetFactoryByGroupID',
        'groupID=' + parseInt(groupID)
    );
    let factoryArray = [];
    for (let item of Object.entries(response.data)) {
        factoryArray[item[1]['factoryID']] = item[1]['factoryName'];
    }
    return factoryArray;
}

async function GetBankReconciliationReport(chequeRegisterModel) {
    let response = await CommonPost(
        '/api/BankReconciliationReport/GetBankReconciliationReport',
        null,
        chequeRegisterModel
    );
    return response;
}

async function SaveReconciliationCompleteData(completeData) {
    let response = await CommonPost(
        '/api/BankReconciliationReport/SaveReconciliationCompleteData',
        null,
        completeData
    );
    return response;
}

async function getfactoriesForDropDown(groupID) {
    var factoryArray = [];

    const response = await CommonGet(
        '/api/Group/GetFactoryByGroupID',
        'groupID=' + groupID
    );
    for (let item of Object.entries(response.data)) {
        factoryArray[item[1]['factoryID']] = item[1]['factoryName'];
    }
    return factoryArray;
}

async function getGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]['isActive'] === true) {
            groupArray[item[1]['groupID']] = item[1]['groupName'];
        }
    }
    return groupArray;
}

async function GetReconciliationClosingBalance(model) {
    let response = await CommonPost(
        '/api/BankReconciliationReport/GetReconciliationClosingBalance',
        null,
        model
    );
    return response;
}

async function getTranLedgerListForDropdown(factoryID) {
    var ledgerArray = [];
    const response = await CommonGet('/api/BankReconciliationReport/GetTranLedgerListForDropdown', "factoryID=" + parseInt(factoryID));
    for (let item of Object.entries(response.data)) {
        ledgerArray[item[1]["ledgerAccountID"]] = item[1]["ledgerAccountName"];
    }
    return ledgerArray;
}

async function getTranLedgerListForDropdownAuto(factoryID) {
    const response = await CommonGet('/api/BankReconciliationReport/GetTranLedgerListForDropdown', "factoryID=" + parseInt(factoryID));
    return response.data;
}